import { Alert, alertTypes } from "@visiblethread/react-components";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideInlineAlert } from "slices/app/appSlice";
import { selectInlineAlert } from "slices/app/selectors";

const InlineAlertHolder = () => {
  const dispatch = useDispatch();
  const alert = useSelector(selectInlineAlert);

  useEffect(() => {
    return () => {
      dispatch(hideInlineAlert());
    };
  }, []);

  if (!alert) {
    return null;
  }

  return (
    <Alert
      type={alertTypes.inline}
      variant={alert.variant}
      text={alert.text}
      hideCloseButton
    />
  );
};

export default InlineAlertHolder;
